module.exports = [
  {
    'label': 'united states',
    'imageName': 'usa.svg',
    'countryCode': '1',
    'isoCode': 'US'
  },
  {
    'label': 'united kingdom',
    'imageName': 'uk.svg',
    'countryCode': '44',
    'isoCode': 'UK'
  },
  {
    'label': 'canada',
    'imageName': 'canada.svg',
    'countryCode': '1',
    'isoCode': 'CA'
  },
  {
    'label': 'australia',
    'imageName': 'australia.svg',
    'countryCode': '61',
    'isoCode': 'AU'
  }
].map((c) => ({...c, imageUrl: require(`../../assets/images/flags/${c.imageName}`)}));

